import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ApplicationInfoModel} from '../models/application-info.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInfoService {

  constructor(private readonly httpClient: HttpClient) {
  }

  public getApplicationInfo(): Observable<ApplicationInfoModel> {
    return this.httpClient.get<ApplicationInfoModel>(environment.backendUrl + '/actuator/info');
  }
}
